(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-vendor-ima"] = factory(require("mggp-player"));
	else
		root["mggp-vendor-ima"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/MggpVendorIMA.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/IMAWrapper.js":
/*!***************************!*\
  !*** ./src/IMAWrapper.js ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Created by User on 03/03/2016.
 */

var IMAWrapper = function () {
  function IMAWrapper(vendor) {
    var _this = this;

    _classCallCheck(this, IMAWrapper);

    this._vendor = vendor;
    this._started = false;
    this._playing = false;
    this._videoSlot = null;

    this._adDisplayContainer = null;
    this._adLoader = null;
    this._adRequest = null;
    this._url = null;

    this._adManagerLoadedListener = this._onAdManagerLoaded.bind(this);
    this._adErrorListener = this._onAdError.bind(this);
    this._adEventListener = this._onAdEvent.bind(this);
    this._onWindowResize = this._onWindowResize.bind(this);

    var videoInstances = this._vendor.player.get('videoInstances');
    if (videoInstances) {
      videoInstances.forEach(function (video) {
        if (video.className.indexOf('ad:vendor:video') !== -1) {
          _this._videoSlot = video;
        }
      });
    }

    window.addEventListener('resize', this._onWindowResize);
  }

  _createClass(IMAWrapper, [{
    key: 'dispose',
    value: function dispose() {
      this._vendor = null;
      this._started = false;
      this._playing = false;
      this._videoSlot = null;
      this._adDisplayContainer = null;
      this._adLoader = null;
      this._adRequest = null;
      this._url = null;
      window.removeEventListener('resize', this._onWindowResize);
      if (this._adManager) {
        this._adManager.destroy();
        this._adManager = null;
      }
    }
  }, {
    key: 'setVastDocument',
    value: function setVastDocument(vastDocument) {
      this._vastDocument = vastDocument;
    }
  }, {
    key: 'load',
    value: function load(url) {
      this._url = url;

      if (this._videoSlot) {
        this._videoSlot.style.height = '100%';
        this._videoSlot.style.display = 'inline-block';
      }

      this._adDisplayContainer = new google.ima.AdDisplayContainer(this._vendor._iframeContainer, this._videoSlot);
      this._adDisplayContainer.initialize();

      this._adLoader = new google.ima.AdsLoader(this._adDisplayContainer);

      // Listen and respond to ads loaded and error events.
      this._adLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this._adManagerLoadedListener, false);
      this._adLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this._adErrorListener, false);

      this._adRequest = new google.ima.AdsRequest();
      this._adRequest.adTagUrl = this._url;
      // this._adRequest.adTagUrl = 'http://pubads.g.doubleclick.net/gampad/ads?sz=400x300&' +
      // 'iu=%2F6062%2Fiab_vast_samples&ciu_szs=300x250%2C728x90&gdfp_req=1&' +
      // 'env=vp&output=vast&unviewed_position_start=1&url=' +
      // '[referrer_url]&correlator=[timestamp]&cust_params=iab_vast_samples' +
      // '%3Dlinear;';

      // Specify the linear and nonlinear slot sizes. This helps the SDK to
      // select the correct creative if multiple are returned.

      var parentStyle = window.getComputedStyle(this._vendor.container);
      // this._adRequest.linearAdSlotWidth = parseInt(parentStyle.width);
      // this._adRequest.linearAdSlotHeight = parseInt(parentStyle.height);
      //
      // this._adRequest.nonLinearAdSlotWidth = parseInt(parentStyle.width);
      // this._adRequest.nonLinearAdSlotHeight = parseInt(parentStyle.height);

      this._adRequest.linearAdSlotWidth = 690;
      this._adRequest.linearAdSlotHeight = 390;

      this._adRequest.nonLinearAdSlotWidth = 690;
      this._adRequest.nonLinearAdSlotHeight = 200;

      this._adLoader.requestAds(this._adRequest);
    }
  }, {
    key: 'start',
    value: function start() {
      if (!this._started && this._adManager) {
        this._adManager.start();
        this._started = true;
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this._adManager) {
        if (this._adManager.getRemainingTime() > 0) {
          this._adManager.stop();
          this._started = false;
        }
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      if (this._playing && this._adManager) {
        this._adManager.pause();
        this._playing = false;
        this._vendor._setState(2);
      }
    }
  }, {
    key: 'resume',
    value: function resume() {
      if (!this._playing && this._adManager) {
        this._adManager.resume();
        this._playing = true;
      }
    }
  }, {
    key: '_onAdManagerLoaded',
    value: function _onAdManagerLoaded(adsManagerLoadedEvent) {
      var _this2 = this;

      var adRenderingSettings = new google.ima.AdsRenderingSettings();
      adRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;
      adRenderingSettings.useStyledNonLinearAds = true;
      //adRenderingSettings.autoAlign = false;
      // videoContent should be set to the content video element.
      this._adManager = adsManagerLoadedEvent.getAdsManager({ currentTime: 1 }, adRenderingSettings);

      // Add listeners to the required events.
      this._adManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this._adErrorListener);
      this._adManager.addEventListener(google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, this._onContentPauseRequested.bind(this));
      this._adManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, this._onContentResumeRequested.bind(this));
      this._adManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, this._adEventListener);

      // Listen to any additional events, if necessary.
      this._adManager.addEventListener(google.ima.AdEvent.Type.LOADED, this._adEventListener);
      this._adManager.addEventListener(google.ima.AdEvent.Type.IMPRESSION, this._adEventListener);
      this._adManager.addEventListener(google.ima.AdEvent.Type.STARTED, this._adEventListener);
      this._adManager.addEventListener(google.ima.AdEvent.Type.CLICK, this._adEventListener);
      this._adManager.addEventListener(google.ima.AdEvent.Type.SKIPPED, this._adEventListener);

      this._adManager.addEventListener(google.ima.AdEvent.Type.FIRST_QUARTILE, this._adEventListener);
      this._adManager.addEventListener(google.ima.AdEvent.Type.MIDPOINT, this._adEventListener);
      this._adManager.addEventListener(google.ima.AdEvent.Type.THIRD_QUARTILE, this._adEventListener);
      this._adManager.addEventListener(google.ima.AdEvent.Type.RESUMED, this._adEventListener);
      this._adManager.addEventListener(google.ima.AdEvent.Type.PAUSED, this._adEventListener);

      this._adManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, this._adEventListener);
      this._adManager.addEventListener(google.ima.AdEvent.Type.USER_CLOSE, this._adEventListener);
      this._adManager.addEventListener(google.ima.AdEvent.Type.DURATION_CHANGE, this._adEventListener);
      this._adManager.addEventListener(google.ima.AdEvent.Type.AD_PROGRESS, this._adEventListener);

      if (window.skinUtils) {
        this._vendor.player.on(window.skinConsts.FULLSCREEN_STATE_CHANGED, function () {
          _this2._resizeAd();
        });
      }

      try {
        // Initialize the ads manager. Ad rules playlist will start at this time.
        var width = 690,
            height = 390;
        if (this._vendor.container) {
          width = this._vendor.container.offsetWidth;
          height = this._vendor.container.offsetHeight;
        }

        this._adManager.init(width, height, this._isFullscreen() ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL);
      } catch (adError) {
        // An error may be thrown if there was a problem with the VAST response.
        this._vendor.stop();
      }
    }
  }, {
    key: '_resizeAd',
    value: function _resizeAd() {
      if (this._adManager) {
        var width = 690,
            height = 390;
        if (this._vendor.container) {
          width = this._vendor.container.offsetWidth;
          height = this._vendor.container.offsetHeight;
        }

        this._adManager.resize(width, height, this._isFullscreen() ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL);
      }
    }
  }, {
    key: '_onAdError',
    value: function _onAdError(event) {
      console.log('IMADisplayingElement error: ' + event.getError().toString());
      if (this._adManager) {
        this._adManager.destroy();
      }

      this._vendor.emit('mediaError');
    }
  }, {
    key: '_onAdEvent',
    value: function _onAdEvent(event) {
      var ad = event.getAd();
      switch (event.type) {
        case google.ima.AdEvent.Type.LOADED:
          this._vendor.emit('imaIsLinear', ad.isLinear());
          this._vendor.emit('vendorCreate');
          this._vendor.emit('mediaCanPlay');
          this._vendor.emit('loadedFraction', 1);
          this.volume = !this._vendor.player.get('muted') ? this._vendor.player.get('volume') / 100 : 0;
          this._resizeAd();
          break;
        case google.ima.AdEvent.Type.STARTED:
          this._vendor.player.off('globalUpdate', this._globalUpdateListener);
          this._playing = true;
          this._vendor._setState(1);
          break;
        case google.ima.AdEvent.Type.COMPLETE:
          this._trackEvent('complete');
          break;
        case google.ima.AdEvent.Type.IMPRESSION:
          this._trackEvent('impression');
          setTimeout(this._trackEvent, 20, 'creativeView');
          this._vendor.emit('imaIsLinear', ad.isLinear());
          this.volume = !this._vendor.player.get('muted') ? this._vendor.player.get('volume') / 100 : 0;
          this._vendor.player.set('ad:vendor:duration', 0);
          this._vendor.player.set('ad:vendor:position', 0);
          if (!ad.isLinear()) {
            this._resizeAd();
          }
          break;
        case google.ima.AdEvent.Type.FIRST_QUARTILE:
          this._trackEvent('firstQuartile');
          break;
        case google.ima.AdEvent.Type.MIDPOINT:
          this._trackEvent('midpoint');
          break;
        case google.ima.AdEvent.Type.THIRD_QUARTILE:
          this._trackEvent('thirdQuartile');
          break;
        case google.ima.AdEvent.Type.SKIPPED:
          this._trackEvent('skip');
          break;
        case google.ima.AdEvent.Type.CLICK:
          this._vendor.player.emit('ad:skin:clickOnBg');
          if (this._vendor.player.get('state') === 1) {
            this._vendor.player.pause();
          }
          break;
        case google.ima.AdEvent.Type.AD_PROGRESS:
          var data = event.getAdData();
          this._vendor.player.set('ad:vendor:duration', data.duration);
          this._vendor.player.set('ad:vendor:position', data.currentTime);
          break;
        case google.ima.AdEvent.Type.DURATION_CHANGE:
          if (this._started && !this._playing && this._adManager) {
            this._adManager.destroy();
            return;
          }
          if (this._adManager && typeof this._adManager.getDuration === 'function') {
            this._vendor.updateDuration(this._adManager.getDuration());
          }
          break;

        case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
        case google.ima.AdEvent.Type.USER_CLOSE:
          this._trackEvent('close');
          this._vendor._setState(0);
          break;
        case google.ima.AdEvent.Type.PAUSED:
          this._playing = false;
          this._vendor._setState(2);
      }
    }
  }, {
    key: '_trackEvent',
    value: function _trackEvent(event) {
      if (this._vastDocument && typeof this._vastDocument[event] === 'function') {
        this._vastDocument[event]();
      }
    }
  }, {
    key: '_onWindowResize',
    value: function _onWindowResize() {
      this._resizeAd();
    }
  }, {
    key: '_isFullscreen',
    value: function _isFullscreen() {
      return Boolean(document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement);
    }
  }, {
    key: '_onContentResumeRequested',
    value: function _onContentResumeRequested(event) {}
  }, {
    key: '_onContentPauseRequested',
    value: function _onContentPauseRequested(event) {}
  }, {
    key: 'volume',
    set: function set(value) {
      if (this._adManager) {
        if (Number.isNaN(value)) {
          value = 0.6;
        }if (value > 1) {
          value = 1;
        } else if (value < 0) {
          value = 0;
        }
        this._adManager.setVolume(value);
      }
    },
    get: function get() {
      return this._adManager ? this._adManager.getVolume() : 0;
    }
  }, {
    key: 'playing',
    get: function get() {
      return this._playing;
    }
  }]);

  return IMAWrapper;
}();

exports.default = IMAWrapper;

/***/ }),

/***/ "./src/MggpVendorIMA.js":
/*!******************************!*\
  !*** ./src/MggpVendorIMA.js ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mggpPlayer = __webpack_require__(/*! mggp-player */ "mggp-player");

var _IMAWrapper = __webpack_require__(/*! ./IMAWrapper */ "./src/IMAWrapper.js");

var _IMAWrapper2 = _interopRequireDefault(_IMAWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class MggpVendorAdsense
 */
var MggpVendorIMA = function (_Vendor) {
	_inherits(MggpVendorIMA, _Vendor);

	function MggpVendorIMA(pPlayer, pConfig) {
		_classCallCheck(this, MggpVendorIMA);

		var _this = _possibleConstructorReturn(this, (MggpVendorIMA.__proto__ || Object.getPrototypeOf(MggpVendorIMA)).call(this, pPlayer, pConfig));

		_this.IMA_SDK_URL = '//imasdk.googleapis.com/js/sdkloader/ima3.js';
		_this.GOOGLE_TAG_SDK_URL = '//securepubads.g.doubleclick.net/tag/js/gpt.js';
		_this.GOOGLE_TAG_DEFINED_PROPERTY = 'ga:slotDefined';

		_this._autoPlay = true;
		_this._iframeContainer = null;
		_this._volumeBeforeMute = -1;
		_this._wrapper = new _IMAWrapper2.default(_this);
		_this._duration = -1;
		_this._currentTime = 0;
		_this._startTime = 0;

		_this._scriptListener = _this._onScriptEvent.bind(_this);
		_this._thisListener = _this._onCreate.bind(_this);
		_this._globalUpdate = _this._onGlobalUpdate.bind(_this);

		_this.player.registerProperty(_this.GOOGLE_TAG_DEFINED_PROPERTY, false, true);

		if (!_this.player.config.needDefineGASlot) return _possibleConstructorReturn(_this);
		_this._insertScriptToHead(_this.GOOGLE_TAG_SDK_URL);
		return _this;
	}

	_createClass(MggpVendorIMA, [{
		key: 'dispose',
		value: function dispose() {
			if (this._scriptElement && this._scriptElement.parentNode) {
				this._scriptElement.parentNode.removeChild(this._scriptElement);
			}
			if (this._iframeContainer && this._iframeContainer.parentNode) {
				this._iframeContainer.parentNode.removeChild(this._iframeContainer);
			}
			//if (this.container.parentNode) {
			//	this.container.parentNode.removeChild(this.container);
			//}
			if (this.player) {
				this.player.off(this.namespace + 'vendorCreate', this._thisListener);
				this.player.off('player:timeUpdate', this._globalUpdate);
			}
			this._wrapper.dispose();

			this._scriptLoaded = false;
			this._volumeBeforeMute = -1;
			this._loadCalled = false;
			this._src = null;
			this._iframeContainer = null;
			this._scriptElement = null;
			this._duration = -1;
			this._playing = false;
			this._beforeCompleteFired = false;
			this.player = null;
			this.namespase = null;

			this.config = null;
			this.options = null;

			this.emit('vendorDestroy');
		}
	}, {
		key: 'load',
		value: function load(src, videoInfo, options) {
			this.checkOptions(options);

			this._src = src;
			this._options = this.options = options;

			this._wrapper.setVastDocument(options.vastDocument);

			if (window.google && window.google.ima) {
				this._load();
			} else {
				this._scriptElement = this._insertScriptToHead(this.IMA_SDK_URL, this._scriptListener);
			}

			// https://jira.x2sy.com/browse/MR-6314
			// По нормальному размечать блоки на странице должен сайт, логика в том что у нас на странице может быть N слотов
			// И на каждый слот мы можем в админке гугла настраивать рекламу. ID можно захардкодить, но оно приходит в ссылке
			// adList, меня уверяют что оно не меняется, но я не хочу хардкодить.
			// Как обычно этому не место в плеере, размечать должна страница, но такую задачу не сделать за день.
			if (!this.player.config.needDefineGASlot) return;
			if (this.player.get(this.GOOGLE_TAG_DEFINED_PROPERTY)) return;
			var urlParser = this.player.config.getURLParser(src);
			if (urlParser.query.iu) {
				window.googletag = window.googletag || { cmd: [] };
				this.player.set(this.GOOGLE_TAG_DEFINED_PROPERTY, true);

				var iu = urlParser.query.iu;
				var playerContainer = this.player.config.container;
				googletag.cmd.push(function () {
					googletag.defineSlot(iu, [playerContainer.clientWidth, playerContainer.clientHeight], playerContainer.id).addService(googletag.pubads());

					googletag.enableServices();
				});
			}
		}
	}, {
		key: 'play',
		value: function play() {
			if (this._duration !== -1) {
				this._startTime = new Date().getTime() / 1000;
				this.player.on('player:timeUpdate', this._globalUpdate);
			}
			if (!this._wrapper._started) {
				this._wrapper.start();
			} else {
				this._wrapper.resume();
			}
			this._setState(1);
		}
	}, {
		key: 'stop',
		value: function stop() {
			this._wrapper.stop();
			this._setState(0);
			this.dispose();
		}
	}, {
		key: 'pause',
		value: function pause() {
			this._setState(2);
			this._wrapper.pause();
		}
	}, {
		key: 'togglePlayPause',
		value: function togglePlayPause() {
			if (this._wrapper.playing) {
				this._wrapper.pause();
			} else {
				this._wrapper.resume();
			}
		}
	}, {
		key: 'seekTo',
		value: function seekTo() {}

		//volume range [0; 100]

	}, {
		key: 'setVolume',
		value: function setVolume(volume) {
			if (volume > 100) {
				volume = 100;
			} else if (volume < 0) {
				volume = 0;
			}
			this._wrapper.volume = volume / 100;
			this.set('volume', volume);
		}
	}, {
		key: 'mute',
		value: function mute() {
			this._volumeBeforeMute = this._wrapper.volume;
			this._wrapper.volume = 0;
			this.set('muted', true);
		}
	}, {
		key: 'unMute',
		value: function unMute() {
			if (!this.get('muted')) return;
			this._wrapper.volume = this._volumeBeforeMute !== -1 ? this._volumeBeforeMute : .6;
			this._volumeBeforeMute = -1;
			this.set('muted', false);
		}
	}, {
		key: '_load',


		//Privates
		value: function _load() {
			if (this._options) {
				this.checkOptions(this._options);
				if ('duration' in this._options) {
					this._duration = this._options['duration'];
				}
			}
			this._setState(5);
			if (this.player) {
				this.player.on(this.namespace + 'vendorCreate', this._thisListener);
			}
			this._createDomElements();
			this._wrapper.load(this._src);
		}
	}, {
		key: '_onScriptEvent',
		value: function _onScriptEvent(event) {
			if (this._scriptElement) {
				this._scriptElement.removeEventListener('load', this._scriptListener);
				this._scriptElement.removeEventListener('error', this._scriptListener);
			}
			switch (event.type) {
				case 'load':
					this._load();
					break;
				case 'error':
					this.emit('error');
					this.dispose();
					break;
			}
		}
	}, {
		key: '_onCreate',
		value: function _onCreate(event) {
			if (this._autoPlay) {
				this.play();
			}
		}
	}, {
		key: '_onGlobalUpdate',
		value: function _onGlobalUpdate(event) {
			if (this._wrapper.playing) {
				this._currentTime = new Date().getTime() / 1000 - this._startTime;
				if (this._currentTime >= this._duration) {
					this._setState(0);
				}
			}
		}
	}, {
		key: '_setState',
		value: function _setState(newState) {
			newState = parseInt(newState);
			this.set('state', newState);
			this.emit('stateChange', newState);
		}
	}, {
		key: '_createDomElements',
		value: function _createDomElements() {
			this._iframeContainer = document.createElement('div');
			// this._iframeContainer.style.position = 'absolute';
			this._iframeContainer.id = "imaContainer";
			this.container.appendChild(this._iframeContainer);
		}
	}, {
		key: '_updateDuration',
		value: function _updateDuration(duration) {
			this._duration = duration;
		}
	}, {
		key: '_insertScriptToHead',
		value: function _insertScriptToHead(url, listener) {
			var script = document.createElement('script');
			script.type = 'text/javascript';
			if (listener) {
				script.addEventListener('load', listener);
				script.addEventListener('error', listener);
			}

			document.head.appendChild(script);
			script.src = url;
			return script;
		}
	}, {
		key: 'autoPlay',
		get: function get() {
			return this._autoPlay;
		},
		set: function set(value) {
			this._autoPlay = Boolean(value);
		}
	}], [{
		key: 'canPlay',
		value: function canPlay(extension) {
			return extension === MggpVendorIMA.mimeTypes[0];
		}
	}]);

	return MggpVendorIMA;
}(_mggpPlayer.Vendor);

exports.default = MggpVendorIMA;

MggpVendorIMA.priority = 0;
MggpVendorIMA.mimeTypes = ['ima'];

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});